import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TPartnerDM from './TPartnerDM'
import TContactPersonDM from './TContactPersonDM'

/**
 * Kontaktní osoby a partneři - položky
 */
export default class TMarketingActivityItemP2PDM extends Data {
	public static className = 'TMarketingActivityItemP2PDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * MasterRID
	 */
	MasterRID?: number

	/**
	 * Typ
	 */
	LinkTypeId?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * T
	 */
	DefaultValueImgCalc?: string

	/**
	 * AuxiliaryRID
	 */
	@Type(() => TPartnerDM)
	AuxiliaryRID?: TPartnerDM

	/**
	 * SlaveRID
	 */
	@Type(() => TContactPersonDM)
	SlaveRID?: TContactPersonDM
}